



































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { IVendor } from '@/api/types-vendor'
import { getDistanceFromLatLonInMiles } from '@/utils/distance'
import { IOrderData } from '@/api/types'

@Component({
  name: 'VendorData'
})

export default class extends Vue {
  @Prop({ type: Object }) vendor!: IVendor;
  @Prop({ type: Object }) order!: IOrderData;
  @Prop({ type: Boolean, default: false }) hideFee: Boolean;
  distance = 0.0

  mounted() {
    this.fetchData()
  }

  @Watch('vendor') onVendorChange(val: boolean) {
    console.log('vendor changed! ' + val)
    if (this.vendor !== null) {
      console.log(`onVendorChange order.vendorId=${this.order.vendorId} vendor.vendorId=${this.vendor.vendorId}.`)
    } else {
      console.log(`onVendorChange order.vendorId=${this.order.vendorId} vendor is null`)
    }
  }

  fetchData() {
    if (this.vendor && this.vendor.latitude) {
      const result = getDistanceFromLatLonInMiles(
        this.order.latitude || 0, this.order.longitude || 0,
        this.vendor.latitude || 0, this.vendor.longitude || 0)
      this.distance = result
    }
  }
}
